import FileDownload from 'js-file-download'
import json2csv from 'json2csv'
import { format } from 'date-fns'
import produceDownloadForSAP, {
  accountingManagerDownload
} from './produceDownloadForSAP'
const convertToCSV = json2csv.parse

const formatDate = date => {
  let dateArray = ''
  let month = ''
  let day = ''
  let year = ''

  if (date.length === 10) {
    dateArray = date.split('/')
    month = dateArray[0]
    day = dateArray[1]
    year = dateArray[2]
  } else {
    dateArray = date.split('-')
    month = dateArray[1]
    day = dateArray[2].substring(0, 2)
    year = dateArray[0]
  }
  switch (dateArray[1]) {
    case '02':
      month = 'Feb'
      break
    case '03':
      month = 'Mar'
      break
    case '04':
      month = 'Apr'
      break
    case '05':
      month = 'May'
      break
    case '06':
      month = 'Jun'
      break
    case '07':
      month = 'Jul'
      break
    case '08':
      month = 'Aug'
      break
    case '09':
      month = 'Sep'
      break
    case '10':
      month = 'Oct'
      break
    case '11':
      month = 'Nov'
      break
    case '12':
      month = 'Dec'
      break
    default:
      month = 'Jan'
  }
  return `${month} ${day}, ${year}`
}

const currentDate = () => {
  const dateArray = Date().split(' ')
  let month = ''
  const day = dateArray[2]
  const year = dateArray[3]
  switch (dateArray[1]) {
    case 'Feb':
      month = '02'
      break
    case 'Mar':
      month = '03'
      break
    case 'Apr':
      month = '04'
      break
    case 'May':
      month = '05'
      break
    case 'Jun':
      month = '06'
      break
    case 'Jul':
      month = '07'
      break
    case 'Aug':
      month = '08'
      break
    case 'Sep':
      month = '09'
      break
    case 'Oct':
      month = '10'
      break
    case 'Nov':
      month = '11'
      break
    case 'Dec':
      month = '12'
      break
    default:
      month = '01'
  }
  return `${year}-${month}-${day}`
}

const dateWithComma = date => {
  const newDate = date.split(' ')
  const month = newDate[0]
  const day = newDate[1]
  const year = newDate[2]
  return `${month} ${day}, ${year}`
}

export const DownloadPhase1 = async crfList => {
  // const csvData = []
  let status = ''
  for (const obj of crfList) {
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }
  const csvData = await produceDownloadForSAP(crfList)
  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}
export const DownloadPhase1AM = async crfList => {
  let status = ''
  for (const obj of crfList) {
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }
  const csvData = await produceDownloadForSAP(crfList)
  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadToApproved = async crfList => {
  let status = ''
  for (const obj of crfList) {
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  const csvData = await produceDownloadForSAP(crfList)
  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadApproved = async crfList => {
  let status = ''
  for (const obj of crfList) {
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  const csvData = await produceDownloadForSAP(crfList)
  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadInProcess = async crfList => {
  let status = ''
  for (const obj of crfList) {
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  const csvData = await produceDownloadForSAP(crfList)
  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadPhase2 = async arg => {
  const crfList = []
  let status = ''
  if (arg[1] === 'in process') {
    for (const obj of arg[0]) {
      crfList.push(obj)
      if (status === '' || status === obj.status) {
        status = obj.status
      } else {
        status = 'All_Request'
      }
    }
  }

  if (arg[1] === 'check preparation') {
    for (const obj of arg[0]) {
      crfList.push(obj)
      if (status === '' || status === obj.status) {
        status = obj.status
      } else {
        status = 'All_Request'
      }
    }
  }

  if (arg[1] === 'check prepared') {
    for (const obj of arg[0]) {
      crfList.push(obj)
      if (status === '' || status === obj.status) {
        status = obj.status
      } else {
        status = 'All_Request'
      }
    }
  }

  if (arg[1] === 'check available') {
    for (const obj of arg[0]) {
      crfList.push(obj)
      if (status === '' || status === obj.status) {
        status = obj.status
      } else {
        status = 'All_Request'
      }
    }
  }

  if (arg[1] === 'released') {
    for (const obj of arg[0]) {
      crfList.push(obj)
      if (status === '' || status === obj.status) {
        status = obj.status
      } else {
        status = 'All_Request'
      }
    }
  }

  const csvData = await produceDownloadForSAP(crfList)
  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadCheckPreparation = async crfList => {
  let status = ''
  for (const obj of crfList) {
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  const csvData = await produceDownloadForSAP(crfList)
  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadCheckPrepared = async crfList => {
  let status = ''
  for (const obj of crfList) {
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  const csvData = await produceDownloadForSAP(crfList)
  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadCheckAvailable = async crfList => {
  let status = ''
  for (const obj of crfList) {
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  const csvData = await produceDownloadForSAP(crfList)
  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadReleased = async crfList => {
  let status = ''
  for (const obj of crfList) {
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  const csvData = await produceDownloadForSAP(crfList)
  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}
